// Please replace, if IE11-support isn't required any longer.
//import {useFormContext} from 'react-hook-form';
import {useFormContext} from 'react-hook-form/dist/react-hook-form.ie11';

import * as React from 'react';
import ReCaptcha from "react-google-recaptcha";

const GOOGLE_DEVELOPER_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

type ReCaptchaProps = {
    name?: string;
    sitekey?: string;
}
export default ({name = 'hidden.recaptcha', sitekey}: ReCaptchaProps) => {
    const {setValue, register, unregister} = useFormContext();
    const onChange = (value: string) => setValue(name, value, true);

    React.useEffect(() => {
        register({name}, {required: true});

        return () => {
            unregister(name);
        };
    }, []);

    return (
		<ReCaptcha
			sitekey={sitekey || GOOGLE_DEVELOPER_KEY}
			{...{onChange}}
		/>
    );
};
